/* Home v3 DR - Digital Runner
   - Caroselli (Blog e video DR, Store DR): frecce, pallini, stato frecce ai bordi
   - Video YouTube: l'iframe si carica solo al clic (youtube-nocookie)
   Supporta piu' sezioni nella stessa pagina e il ricaricamento nel customizer. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initCarousel(root) {
    var track = root.querySelector('[data-hv-track]');
    if (!track) return;
    var prev = root.querySelector('[data-hv-prev]');
    var next = root.querySelector('[data-hv-next]');
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-hv-dot]'));
    var paged = root.hasAttribute('data-hv-dots');

    function step() { return paged ? track.clientWidth : track.clientWidth * 0.8; }
    function go(left) { track.scrollTo({ left: left, behavior: reduce ? 'auto' : 'smooth' }); }

    function update() {
      var max = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max;
      if (dots.length) {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        dots.forEach(function (d, j) {
          if (j === i) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current');
        });
      }
    }

    if (prev) prev.addEventListener('click', function () { go(track.scrollLeft - step()); });
    if (next) next.addEventListener('click', function () { go(track.scrollLeft + step()); });
    dots.forEach(function (d) {
      d.addEventListener('click', function () { go(Number(d.dataset.hvDot) * track.clientWidth); });
    });

    var t;
    track.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(update, 60); }, { passive: true });
    window.addEventListener('resize', update);
    update();

    // Customizer: selezionando un blocco store si scorre alla sua slide
    root.addEventListener('shopify:block:select', function (e) {
      var slide = e.target.closest && e.target.closest('.hv-store__slide_dr');
      if (slide) go(slide.offsetLeft);
    });
  }

  function initVideos(root) {
    root.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-hv-yt]');
      if (!btn) return;
      var id = btn.getAttribute('data-hv-yt');
      if (!/^[\w-]{6,20}$/.test(id)) return;
      var f = document.createElement('iframe');
      f.src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0&modestbranding=1&playsinline=1';
      f.title = btn.getAttribute('data-hv-title') || 'Video YouTube';
      f.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
      f.referrerPolicy = 'strict-origin-when-cross-origin';
      f.allowFullscreen = true;
      // l'iframe non puo' stare dentro un <button>: lo sostituisco con un div
      var box = document.createElement('div');
      box.className = btn.className + ' is-playing';
      box.appendChild(f);
      btn.replaceWith(box);
    });
  }

  function init(scope) {
    (scope || document).querySelectorAll('.hv_dr').forEach(function (root) {
      if (root.dataset.hvReady) return;
      root.dataset.hvReady = '1';
      if (root.hasAttribute('data-hv-carousel')) initCarousel(root);
      if (root.querySelector('[data-hv-yt]')) initVideos(root);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
